import HttpStatus from "http-status-codes";

export const HttpStatusCodes = {
  SUCCESS: [HttpStatus.OK, HttpStatus.CREATED, HttpStatus.ACCEPTED],
  ERROR: [HttpStatus.BAD_REQUEST, HttpStatus.NOT_FOUND],
  UNAUTHORIZED: [HttpStatus.UNAUTHORIZED],
  INTERNAL_SERVER_ERROR: [HttpStatus.INTERNAL_SERVER_ERROR],
};

export const isValidEmail = (email: string): boolean => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};
